import React, { useContext, useState, useEffect, useMemo } from 'react'
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography, Box, Select, MenuItem, FormControl, InputLabel, Grid } from "@mui/material";
import { ThemeContext } from '../../../../context/ThemeContext';
import { createAlerts, deleteAlert, updateAlert } from '../../../../api/request/dashboard/dashboard';
import toast from "react-hot-toast";
import EditAlertDialog from './EditAlertDialog';
import DeleteAlert from './DeleteAlert';
import AlertCellConfig from '../../../tablecells/Alerts';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSymbolPrices } from '../../../../context/WebSocketContext';
import { TableVirtuoso } from "react-virtuoso";
import { saveAlertData, updateAlertData, deleteAlertData } from '../../../../store/Slices/alertSlice';
import NoDataTable from '../../../table/NoDataTable';
import BidValue from '../../../global/BidAsk/BidValue';
import AskValue from '../../../global/BidAsk/AskValue';


export default function Alert({ data = [] }) {
  // const [alerts, setAlerts] = useState([]);
  const { darkMode } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState("");
  const [symbolId, setSymbolId] = useState("");
  const [condition, setCondition] = useState("");
  const [type, setType] = useState("");
  const [value, setValue] = useState(0);
  const [additionalSymbol, setAdditionalSymbol] = useState("")
  const [bid, setBid] = useState(null);
  const [ask, setAsk] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const accountId = localStorage.getItem("accountID");
  const handleOpen = () => setOpen(true);
  const [alertToDelete, setAlertToDelete] = useState(null);
  const { t } = useTranslation()
  const [digit, setDigit] = useState(null)
  const { accountSummary = [] } = useSelector(state => state.accountSummary)
  const { alert = [] } = useSelector(state => state.alert)
  // const symbols = useSymbolPrices()
    const { symbols } = useSelector(state => state.watchlist)
  
  const dispatch = useDispatch();

  const handleClose = () => {
    setDescription("");
    setSymbolId("");
    setCondition("");
    setType("");
    setValue(0);
    setAdditionalSymbol("");
    setOpen(false);
  };
  const handleEdit = (alert) => {
    setEditOpen(true);
    setSelectedAlert(alert)
  };

  const handleDeleteOpen = (alert) => {
    console.log('open', alert);

    setAlertToDelete(alert);
    setDeleteOpen(true);
  };
  const handleDelete = async () => {
    if (!alertToDelete) {
      console.error("No alert selected for deletion.");
      return;
    }

    let data = { id: alertToDelete.id, accountId };

    try {
      await deleteAlert(data);
      dispatch(deleteAlertData(alertToDelete.id))
      toast.success("Alert deleted successfully!");
      setDeleteOpen(false);;
    } catch (error) {
      console.error("Error deleting alert:", error);
      toast.error("Failed to delete alert.");
    }
  };
  useEffect(() => {
    if (accountSummary) {
      checkAlertsCondition(accountSummary);
    }
  }, [accountSummary]);

  useEffect(() => {
    if (additionalSymbol) {
      const selectedSymbol = Object.values(symbols).find(
        (symbol) => symbol.symbolID === Number(additionalSymbol)
      );
      if (selectedSymbol) {
        setBid(selectedSymbol.bid);
        setAsk(selectedSymbol.ask);
        setDigit(selectedSymbol.digits)
      }
    }
  }, [symbols, additionalSymbol]);



  const handleSave = async () => {

    if (!accountId || !condition || !type) {
      toast.error("Please fill all fields before saving.");
      return;
    }

    let adjustedValue = value;
    let updatedSymbolId = symbolId;

    if ([3, 4, 5].includes(type)) {
      updatedSymbolId = null;
    } else if (!symbolId) {
      toast.error("Please select a symbol.");
      return;
    }
    if (type === 1 && condition === 4) { // Market Ask with specific condition
      adjustedValue = ask;
    } else if (type === 2 && condition === 4) { // Market Bid with specific condition
      adjustedValue = bid;
    }

    if (type === 1 && condition === 4 && value <= ask) {
      toast.error("Value must be greater than Ask price.");
      return;
    }
    if (type === 2 && condition === 4 && value <= bid) {
      toast.error("Value must be greater than Bid price.");
      return;
    }

    if (type === 3 && condition === 1) { // Balance
      adjustedValue = accountSummary?.balance;
    } else if (type === 4 && condition === 1) { // Equity
      adjustedValue = accountSummary?.equity;
    } else if (type === 5 && condition === 1) { // Margin Level
      adjustedValue = accountSummary?.marginLevel;
    }

    const payload = {
      accountId: Number(accountId),
      // symbolId: Number(symbolId),
      symbolId: updatedSymbolId !== null ? Number(updatedSymbolId) : null,
      condition: Number(condition),
      type: Number(type),
      value: Number(adjustedValue),
    };
    console.log(payload);

    try {
      const response = await createAlerts(payload);

      if (response.status === 200) {
        toast.success("Alert created successfully!");
        handleClose();
        dispatch(saveAlertData([...alert, response.data]));
      }
    } catch (error) {
      console.error("Error creating alert:", error);
      toast.error("Failed to create alert.");
    }
  };

  const handleUpdate = async (updatedAlert) => {
    try {
      console.log("Updated Alert Payload:", updatedAlert);

      // Ensure proper data structure
      const sanitizedPayload = {
        id: updatedAlert.id,
        accountId: Number(updatedAlert.accountId),  // Ensure it's a number
        symbolId: updatedAlert.symbolId ? Number(updatedAlert.symbolId) : null,
        condition: updatedAlert.condition,
        type: updatedAlert.type,
        value: updatedAlert.value,
        enabled: updatedAlert.enabled,
        hitPrice: updatedAlert.hitPrice ? updatedAlert.hitPrice : null,  // Ensure it's a number
      };

      console.log("Sanitized Payload:", sanitizedPayload);

      const response = await updateAlert(sanitizedPayload);
      console.log("API Response:", response);

      if (response.status === 200) {
        toast.success("Alert updated successfully!");
        dispatch(updateAlertData(alert.map(alert => alert.id === updatedAlert.id ? updatedAlert : alert)));
        setEditOpen(false);
      }
    } catch (error) {
      console.error("Error updating alert:", error);
      toast.error("Failed to update alert.");
    }
  };

  const handleSymbolChange = (event) => {
    const selectedSymbolId = event.target.value;
    setSymbolId(selectedSymbolId);
    setAdditionalSymbol(selectedSymbolId);
    const selectedSymbol = symbols[selectedSymbolId];

    if (selectedSymbol) {
      setBid(selectedSymbol.bid);
      setAsk(selectedSymbol.ask);
      setAdditionalSymbol(selectedSymbol.id);

      // Auto-set value based on type & condition
      if (type === 1 && condition === 1) {  // Market Ask & Greater than
        setValue(selectedSymbol.ask);
      } else if (type === 1 && condition === 2) {  // Market Ask & Less than
        setValue(selectedSymbol.ask - 1);
      } else if (type === 2 && condition === 1) {  // Market Bid & Greater than
        setValue(selectedSymbol.bid + 1);
      } else if (type === 2 && condition === 2) {  // Market Bid & Less than
        setValue(selectedSymbol.bid);
      }
    } else {
      setBid(null);
      setAsk(null);
      setAdditionalSymbol("");
    }
  };

  const columns = AlertCellConfig({ handleOpen, handleEdit, handleDeleteOpen, symbols });

  const handleTypeChange = (event) => {
    const selectedType = Number(event.target.value);
    setType(selectedType);

    if (selectedType === 3) { // Balance
      setValue(accountSummary?.balance || 0);
    } else if (selectedType === 4) { // Equity
      setValue(accountSummary?.equity || 0);
    } else if (selectedType === 5) { // Margin Level
      setValue(accountSummary?.marginLevel || 0);
    } else {
      setValue(0);
    }
  };

  const checkAlertsCondition = (accountSummary, ask, bid) => {
    if (Array.isArray(alert)) {
      alert.forEach(alert => {
        if (alert.type === 1 && alert.condition === 1) { // Market Ask and Greater than condition
          if (ask > alert.value) {
            toast.success(`Market Ask alert triggered: ${alert.description}`);
          }
        } else if (alert.type === 1 && alert.condition === 2) { // Market Ask and Less than condition
          if (ask < alert.value) {
            toast.success(`Market Ask alert triggered: ${alert.description}`);
          }
        } else if (alert.type === 2 && alert.condition === 1) { // Market Bid and Greater than condition
          if (bid > alert.value) {
            toast.success(`Market Bid alert triggered: ${alert.description}`);
          }
        } else if (alert.type === 2 && alert.condition === 2) { // Market Bid and Less than condition
          if (bid < alert.value) {
            toast.success(`Market Bid alert triggered: ${alert.description}`);
          }
        } else if (alert.type === 3 && alert.condition === 2) { // Balance and Less than condition
          if (accountSummary?.balance < alert.value) {
            toast.success(`Balance alert triggered: ${alert.description}`);
          }
        } else if (alert.type === 4 && alert.condition === 2) { // Equity and Less than condition
          if (accountSummary?.equity < alert.value) {
            toast.success(`Equity alert triggered: ${alert.description}`);
          }
        } else if (alert.type === 5 && alert.condition === 2) { // Margin Level and Less than condition
          if (accountSummary?.marginLevel < alert.value) {
            toast.success(`Margin Level alert triggered: ${alert.description}`);
          }
        }
      });
    }
  };

  const typeMap = {
    1: " Ask",
    2: " Bid",
    3: "Balance",
    4: "Equity",
    5: "Margin Level",
  };

  const conditionMap = {
    1: "Greater than",
    2: "Less than",
  };

  const Row = useMemo(() => (index, alert) => {
    return (
      <>
        {columns.map((col, colIndex) => (
          <TableCell key={colIndex} sx={{ fontSize: "0.8rem", border: "none", padding: "5px 5px", backgroundColor: darkMode ? "#151924" : "#fff", position: "relative", overflow: "hidden", }}>
            {col.field === "actions" ? col.render(alert) :
              col.field === "id" ? alert.id :
                col.field === "description" ? alert.description :
                  col.field === "type" ? typeMap[alert.type] || alert.type :
                    col.field === "condition"
                      ? `${typeMap[alert.type] || alert.type} ${conditionMap[alert.condition] || alert.condition}  : ${alert.value}` :
                      col.field === "hitPrice"
                        ? (alert.hitPrice !== undefined ? Number(alert.hitPrice)?.toFixed(digit) : "-") :
                        col.field === "hitDateTime"
                          ? (alert.hitDateTime ? new Date(alert.hitDateTime).toLocaleString() : "-") : col.field === "enabled" ? (alert.enabled ? "True" : "False") :
                            alert[col.field] || "-"}
          </TableCell>
        ))}
      </>
    );
  }, [columns, darkMode, t]);

  const fixedHeaderContent = () => {
    return (
      <TableRow sx={{ borderTop: `1px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}` }}>
        {columns.map((col, index) => (
          <TableCell key={index} sx={{ fontSize: "0.85rem", fontWeight: 200, p: 1, backgroundColor: darkMode ? "var(--background-color)" : "var(--white)", border: "none", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, cursor: "pointer", }}>
            {col.title}
          </TableCell>
        ))}
      </TableRow>);
  }

  const VirtuosoTableComponents = {
    Table: (props) => <Table {...props} sx={{ borderCollapse: "separate", tableLayout: "fixed" }} />,
    TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
    TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
  };


  return (
    <>
      <Paper style={{ width: "100%", height: '100%', backgroundColor: darkMode ? "#151924" : "#fff", }}>
        {alert.length === 0 ? (
          <NoDataTable columns={columns} data={alert} noDataMessage={t('noData')} />
        ) : (
          <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", height: '100%' }}>
            <TableVirtuoso data={alert} fixedHeaderContent={fixedHeaderContent} itemContent={Row} components={VirtuosoTableComponents} />
          </Box>)}
      </Paper>

      {/* Alert Creation Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <Box>
          <DialogTitle sx={{ color: "white", p: 2 }} className="bg-primary">
            <Typography id="symbol-details-modal" variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center" >{t('newAlert')}</Typography>
          </DialogTitle>

          <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mt: 3 }}>
              <TextField label={t('description')} variant="outlined" fullWidth sx={{ "& .MuiOutlinedInput-root": { height: 45 } }}
                value={description} onChange={(e) => setDescription(e.target.value)} />

              <FormControl fullWidth variant="outlined">
                <InputLabel sx={{ color: darkMode ? "#ccc" : "#000" }}>{t('condition')}</InputLabel>
                <Select label={t('condition')} value={condition} onChange={(e) => setCondition(e.target.value)} sx={{ height: 45 }}>
                  <MenuItem value={1}>{t('greaterThan')}</MenuItem>
                  <MenuItem value={2}>{t('lessThan')}</MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth variant="outlined">
                <InputLabel sx={{ color: darkMode ? "#ccc" : "#000" }}>{t('type')}</InputLabel>
                <Select label={t('type')} value={type} onChange={handleTypeChange} sx={{ height: 45 }}>
                  <MenuItem value={1}>{t("MarketAsk")}</MenuItem>
                  <MenuItem value={2}>{t('MarketBid')}</MenuItem>
                  <MenuItem value={3}>{t('balance')}</MenuItem>
                  <MenuItem value={4}>{t('equity')}</MenuItem>
                  <MenuItem value={5}>{t('MarginLevel')}</MenuItem>
                </Select>
              </FormControl>

              <TextField label={t('Value')} type="number" variant="outlined" fullWidth defaultValue={0} sx={{ "& .MuiOutlinedInput-root": { height: 45 } }} value={value} onChange={(e) => setValue(e.target.value)}
                onKeyDown={(e) => {
                  setValue((prev) => {
                    let num = parseFloat(prev);
                    let step = num >= 1000 ? 1 : num >= 1 ? 1 : 0.1;

                    if (e.key === "ArrowUp") {
                      return (num + step)?.toFixed(step === 0.1 ? 4 : 2);
                    } else if (e.key === "ArrowDown") {
                      return (num - step)?.toFixed(step === 0.1 ? 4 : 2);
                    }
                    return num;
                  });
                }} />

              {(type === 1 || type === 2) && (
                <>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel>{t('symbol')}</InputLabel>
                    <Select label={t('symbol')} value={additionalSymbol} onChange={handleSymbolChange} sx={{ height: 45 }} MenuProps={{ anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, getContentAnchorEl: null, PaperProps: { style: { maxHeight: 250, overflow: "auto" } }, }}>
                      {Object.values(symbols).map((symbol) => (
                        <MenuItem key={symbol.id} value={symbol.id}>
                          {symbol.name}
                        </MenuItem>
                      ))}

                    </Select>
                  </FormControl>

                  <Grid container sx={{ mt: 1 }}>
                    <Grid item xs={6}>
                      <Typography variant="body1">{t('bid')}</Typography>
                      {/* <Typography variant="body1" sx={{ color: symbols[additionalSymbol]?.bidColor === "up" ? "#079a80" : symbols[additionalSymbol]?.bidColor === "down" ? "#da5244" : "inherit" }}>
                        {additionalSymbol ? (bid?.toFixed(digit)) : " "}</Typography> */}
                        <BidValue symbolId={additionalSymbol} digits={digit}/>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1">{t('ask')}</Typography>
                      {/* <Typography variant="body1" sx={{ color: symbols[additionalSymbol]?.askColor === "up" ? "#079a80" : symbols[additionalSymbol]?.askColor === "down" ? "#da5244" : "inherit" }}>
                        {additionalSymbol ? (ask?.toFixed(digit)) : " "}</Typography> */}
                        <AskValue symbolId={additionalSymbol} digits={digit}/>
                    </Grid>
                  </Grid>
                </>
              )}

            </Box>
          </DialogContent>

          <DialogActions sx={{ padding: 2, backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
            <Box sx={{ display: "flex", justifyContent: "end", width: "100%" }}>
              <Button onClick={handleClose} variant="outlined" color="primary">{t('cancel')}</Button>
              <Button onClick={handleSave} variant="contained" color="primary" sx={{ ml: 2 }}>{t('save')}</Button>
            </Box>
          </DialogActions>
        </Box>
      </Dialog>
      <EditAlertDialog open={editOpen} handleClose={() => setEditOpen(false)} alertData={selectedAlert} symbolData={symbols} handleUpdate={handleUpdate} />
      <DeleteAlert open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDelete={handleDelete} />
    </>
  )
}
